import moment from 'moment';
import classNames from 'classnames';
import { formatMoneyKr } from '../../utils';
import TrackEventLink from '../../components/track-event-link/TrackEventLink';
import styles from './latest-transactions.module.less';
import { useSelector } from 'react-redux';

const LatestTransactions = () => {
    const transactionsState = useSelector((state) => state.transactions);
    const transactions = (transactionsState.transactions || []).slice(0, 7);
    const push = transactionsState.push;

    const getTimeSinceFormatted = (transactionTime) => {
        const now = moment();
        const diff = moment.duration(now.diff(transactionTime));
        if (diff.days() > 0) {
            return `${diff.days()} dager siden`;
        } else if (diff.hours() > 0) {
            return `${diff.hours()} ${diff.hours() === 1 ? 'time' : 'timer'} siden`;
        } else if (diff.minutes() > 0) {
            return `${diff.minutes()} min siden`;
        } else if (diff.seconds() < 60) {
            return `noen sek siden`;
        }
    };

    const calculateColor = (transactionTime) => {
        const TEN_MINUTES = 60 * 10;

        const colors = ['nordlys-70', 'frost', 'vann'];

        const diff = moment().diff(transactionTime, 'seconds');
        const percent = diff / TEN_MINUTES;
        if (percent >= 1.0) {
            return 'fjell';
        } else {
            return colors[Math.floor(colors.length * percent)];
        }
    };

    const renderElements = [];
    for (let i = 0; i < transactions.length; i++) {
        const firstElement = i === 0;
        const lastShownElement = i >= transactions.length - 2;
        const t = transactions[i];
        const transactionTime = moment(t.date);
        const color = calculateColor(transactionTime);
        const nextColor = !lastShownElement ? calculateColor(moment(transactions[i + 1].date)) : null;

        const lineStyle = nextColor
            ? { background: `linear-gradient(to bottom, var(--${color}), var(--${nextColor})` }
            : { background: `linear-gradient(to bottom, var(--${color}), var(--fjell))` };

        let projectLink;
        if (t.project_id && !t.hidden) {
            projectLink = `/project/${t.project_id}`;
        } else if (t.event) {
            projectLink = `/events/${t.event}`;
        }

        renderElements.push(
            <li
                key={t.id}
                className={classNames(styles.listElement, {
                    [styles.addedElement]: firstElement && push,
                })}
            >
                <div className={styles.listElementContainer}>
                    <div className={styles.timelineGraphics}>
                        <div className={styles.circle} style={{ backgroundColor: `var(--${color})` }} />
                        <div className={styles.line} style={lineStyle} />
                    </div>

                    <div className={styles.listElementText}>
                        {projectLink ? (
                            <TrackEventLink
                                className={styles.projectLink}
                                to={projectLink}
                                category="frontpage-stream"
                                action="click-project"
                                properties={{ projectId: t.project_id }}
                            >
                                {t.project_title}
                            </TrackEventLink>
                        ) : (
                            <span className={styles.projectTitle}>{t.project_title}</span>
                        )}

                        <div className={styles.collectedAndTime}>
                            <div className={styles.collected}>{formatMoneyKr(t.collected)} innsamlet</div>
                            <div className={styles.supportedAt} suppressHydrationWarning>
                                {getTimeSinceFormatted(transactionTime)}
                            </div>
                        </div>
                    </div>
                </div>
            </li>
        );
    }

    return (
        <div className={styles.container}>
            <ul className={styles.elementList}>{renderElements}</ul>
            <div className={styles.dots}>
                <span className={styles.dot} />
                <span className={styles.dot} />
                <span className={styles.dot} />
            </div>
        </div>
    );
};

export default LatestTransactions;
